import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AggregationGroupModel} from "../../shared/models/search/aggregations/aggregation-group.model";
import {ApiResultDispatcherService} from "../../shared/services/api/api-result-dispatcher.service";
import {ApiService} from "../../shared/services/api/api-service";
import {SuggestionsSearchModel} from "../models/suggestions-search.model";

@Injectable({
    providedIn: "root"
})
export class SuggestionsService {
    private API_BASE_URL = "/umbraco/api";

    private API_GET_SUGGESTIONS = `${this.API_BASE_URL}/advancedSearchApi/getCollectionAutocomplete`;

    public constructor(
        private apiService: ApiService,
        private apiDispatcherService: ApiResultDispatcherService
    ) {

    }

    public getSuggestions(params: SuggestionsSearchModel): Observable<AggregationGroupModel> {
        let http = this.apiService.get<AggregationGroupModel>(
            this.API_GET_SUGGESTIONS, {
                searchParams: JSON.stringify(params)
            }
        );

        http = this.apiDispatcherService.dispatchNetworkErrorNotification(http);

        return http;
    }
}
